export default function KompisElementCustomElementDecorator(tagName: string) {
	return function (target: typeof HTMLElement) {
		customElements.define(tagName, target);
	};
}
